// src/services/candidate/workExperienceService.js
import candidateApi from './api';

export const getWorkExperiences = async () => {
  try {
    const response = await candidateApi.get('/work-experience');
    return response.data;
  } catch (error) {
    console.error('Error fetching work experiences:', error);
    throw error;
  }
};

export const createWorkExperience = async (workExperienceData) => {
  try {
    const response = await candidateApi.post('/work-experience/create', workExperienceData);
    return response.data;
  } catch (error) {
    console.error('Error creating work experience:', error);
    throw error;
  }
};

export const updateWorkExperience = async (id, workExperienceData) => {
  try {
    const response = await candidateApi.put(`/work-experience/${id}`, workExperienceData);
    return response.data;
  } catch (error) {
    console.error('Error updating work experience:', error);
    throw error;
  }
};

export const deleteWorkExperience = async (id) => {
  try {
    const response = await candidateApi.delete(`/work-experience/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting work experience:', error);
    throw error;
  }
};